import axios from 'axios'
import { getToken, removeToken } from '@/utils/auth'
import { Message } from 'element-ui'

const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '/api',
  timeout: 15000
})

request.interceptors.request.use(config => {
  const token = getToken()
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token
  }
  return config
})

request.interceptors.response.use(
  response => {
    // 文件下载（blob）：后端直接写二进制流，不返回 {code,msg,data}
    if (response.config.responseType === 'blob') {
      // 后端以 HTTP 200 返回 JSON 错误（业务异常，无 @ResponseStatus）时，axios 会把它包成 Blob
      if (response.data instanceof Blob && response.data.type === 'application/json') {
        return response.data.text().then(text => {
          let msg = '请求失败'
          try { msg = JSON.parse(text).msg || msg } catch (e) { /* ignore */ }
          Message.error(msg)
          return Promise.reject(new Error(msg))
        })
      }
      return response
    }
    const res = response.data
    if (res.code !== 200) {
      Message.error(res.msg || '请求失败')
      return Promise.reject(new Error(res.msg || '请求失败'))
    }
    return res
  },
  async error => {
    // 后端 400/401/403/500 均返回 {code, msg, data}，优先展示后端真实异常信息
    const status = error.response ? error.response.status : 0
    const res = error.response ? error.response.data : null
    let msg = (res && res.msg) ||
      (status === 401 ? '登录已过期，请重新登录' : (error.message || '网络错误'))
    // blob 下载失败时，错误体是 Blob，需解析出真实 msg（如导出时 token 过期的 401 JSON）
    if (error.config && error.config.responseType === 'blob' && res instanceof Blob) {
      try {
        msg = JSON.parse(await res.text()).msg || msg
      } catch (e) { /* ignore parse errors */ }
    }

    if (status === 401) {
      removeToken()
      Message.error(msg)
      // 延迟跳转，让用户看到提示后再回登录页（location 硬跳转以清空内存中的动态路由）
      setTimeout(() => { window.location.href = '/login' }, 800)
    } else {
      Message.error(msg)
    }
    return Promise.reject(error)
  }
)

export default request
